import moment from 'jalali-moment';
import useChooseWinner from 'modules/myAdvertisment/hooks/useChooseWinner';
import React from 'react';
interface ChooseAcutionItemProps {
  item: IPrepaymentAuction;
  index: number;
  chosedSugestionUser: IChosedSugestionUser;
  isSendMSGOpen: boolean;
  isOpenModalParticipated: boolean;
  setIsSendMSGOpen: (isSendMSGOpen: boolean) => void;
  setisOpenModalParticipated: (isOpenModalParticipated: boolean) => void;
  setChosedSugestionUser: (chosedSugestionUser: IChosedSugestionUser) => void;
}
const ChooseAcutionItem = ({
  item,
  index,
  chosedSugestionUser,
  isSendMSGOpen,
  isOpenModalParticipated,
  setChosedSugestionUser,
  setIsSendMSGOpen,
  setisOpenModalParticipated,
}: ChooseAcutionItemProps) => {
  const resetItem = () => {
    setChosedSugestionUser({
      ...chosedSugestionUser,
      profile: item,
      isOpenModal: false,
      isDelete: false,
    });
  };
  const {mutate} = useChooseWinner({cardType: 'auction', action: resetItem});

  return (
    <div className="flex w-full items-center justify-between py-3 text-green-1">
      <div className="pr-3 text-gray-6 w-[10%] flex items-center justify-center text-[14px] gap-1">
        <button
          className="rounded-full w-4 h-4 border border-gray-6 flex items-center justify-center"
          onClick={() =>
            mutate({guid: item.guid, delete: chosedSugestionUser.isDelete})
          }
        >
          {chosedSugestionUser.profile?.guid === item.guid && (
            <span className="bg-green-1 rounded-full w-3 h-3 flex" />
          )}
        </button>
      </div>
      <div className="text-gray-6 w-[30%] flex items-center justify-center">
        {moment(item.created_at).format('jYYYY/jMM/jDD')}
      </div>
      <div className="text-gray-6 w-[30%] flex items-center justify-center">
        {item.price.toLocaleString()}
      </div>
      <div className="w-[10%] flex items-center justify-center">
        <button
          className="icon-account text-[20px] "
          onClick={() => {
            setisOpenModalParticipated(!isOpenModalParticipated);
            setChosedSugestionUser({
              ...chosedSugestionUser,
              profile: item,
            });
          }}
        />
      </div>
      <div className=" w-[10%] flex items-center justify-center">
        <button
          className="icon-chat pl-2 text-[20px]"
          onClick={() => {
            setIsSendMSGOpen(!isSendMSGOpen);
            setChosedSugestionUser({
              ...chosedSugestionUser,
              profile: item,
            });
          }}
        />
      </div>
    </div>
  );
};

export default ChooseAcutionItem;
